import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

export default angular
  .module('books.util.DistributionSpec', [csmCommonWeb])
  .factory('DistributionSpec', DistributionSpecFactory).name;

/*****************************************************************************
 * Tools for splitting a total amount into multiple amounts based an amount or
 * percentage specification. This object contains a distribution percentage or
 * amount for a given source object. The <b>distribute</b> method calculates
 * the amount to distribute for each item in a list of these objects and calls
 * a <b>Distributor</b> method to perform the distribution.
 *****************************************************************************/
/* @ngInject */
function DistributionSpecFactory(Tools) {
  /***************************************************************************
   * Constructor
   *
   * Builds the distribution spec from a source object.
   *
   * @param  source      Source object.
   * @param  amount      Distribution amount, exclusive with percentage.
   * @param  percentage  Distribution percentage, exclusive with amount.
   ***************************************************************************/
  function DistributionSpec(source, amount, percentage) {
    /***************************************************************************
     * Properties
     ***************************************************************************/
    /** Instance reference. */ var mThis = this;
    /** Source object. */ mThis.source = source;
    /** Distribution amount. */ mThis.amount = amount;
    /** Distribution decimal percentage. */ mThis.percentage = percentage;
  }

  /***************************************************************************
   * distribute */
  /**
   * Static function to calculate the amount of <i>totalAmt</i> to distribute
   * for all entries in <i>specList</i> and calls <i>distributor</i> with
   * <i>source</i> and <i>amount</i> for each entry. <i>itemQty</i> is the number
   * of items in <i>totalAmt</i>. <i>specList</i> entries contain the distribution
   * spec for single items.
   *
   * <p><b>Note:</b> <i>distributor</i> is called only when the distribution
   * amount is not zero.</p>
   *
   * @param  specList     Distribution specifications array
   * @param  totalAmt     Total amount to distribute.
   * @param  itemQty      Item quantity.
   * @param  distributor  Function called for each distribution.
   *                        function(source:Object, amount:Number):void
   ***************************************************************************/
  DistributionSpec.distribute = function (
    specList,
    totalAmt,
    itemQty,
    distributor
  ) {
    /*---------------------------*/
    /* List of DistributionSpecs */
    /*---------------------------*/
    var distList = null;
    var pctList = null;

    /*------------------------------------------------------------------*/
    /* If distribution by percentage, use list of percentages as given. */
    /*------------------------------------------------------------------*/
    if ((specList[0].percentage || 0) != 0) pctList = specList;
    /*------------------------------*/
    /* If distribution by amount... */
    /*------------------------------*/ else {
      /*----------------------------------------*/
      /* Get total amount of all distributions. */
      /*----------------------------------------*/
      var distTotal = 0;
      specList.forEach(function (spec) {
        distTotal += spec.amount;
      });

      /*------------------------------------------------------*/
      /* If the distributed amount total does not match the   */
      /* total amount, convert amounts to list of percentages */
      /* proportional to the distributed amount total.        */
      /*------------------------------------------------------*/
      if (distTotal * itemQty != totalAmt)
        pctList = specList.map(function (spec) {
          return new DistributionSpec(spec.source, 0, spec.amount / distTotal);
        });
    }

    /*--------------------------------------*/
    /* If distributing by percentage, build */
    /* distribution list from percentages.  */
    /*--------------------------------------*/
    if (pctList != null) {
      /*-----------------------------------------------------------------------*/
      /* Calculate amounts for percentages by truncating to two decimals       */
      /* instead of rounding. This ensures the resulting total is <= subtotal. */
      /*-----------------------------------------------------------------------*/
      distTotal = 0;
      distList = pctList.map(function (spec) {
        var dist = new DistributionSpec(
          spec.source,
          Math.floor(totalAmt * spec.percentage * 100) / 100,
          0
        );
        distTotal += dist.amount;
        return dist;
      });

      /*-----------------------------------------------------------*/
      /* Distribute the remaining amount across all distributions. */
      /*-----------------------------------------------------------*/
      for (
        var diff = Tools.roundToPrecision(totalAmt - distTotal, 2);
        diff != 0;

      )
        for (var i = 0; i < distList.length && diff != 0; i++)
          if (distList[i].amount != 0) {
            distList[i].amount += 0.01;
            diff = Tools.roundToPrecision(diff - 0.01, 2);
          }
    } else

    /*-----------------------------------------------*/
    /* If distributing by amount, build distribution */
    /* list from amounts adjusted for itemQty.       */
    /*-----------------------------------------------*/
      distList = specList.map(function (spec) {
        return new DistributionSpec(spec.source, spec.amount * itemQty, 0);
      });

    /*-------------------------*/
    /* Distribute the amounts. */
    /*-------------------------*/
    distList.forEach(function (dist) {
      if (dist.amount != 0) distributor(dist.source, dist.amount);
    });
  };

  return DistributionSpec;
}
